import type {PerRevisionKeyInfo} from 'metaserver/static/js/encrypted_folder/content/types';
import {createSymmetricCoreCrypto} from 'metaserver/static/js/encrypted_folder/crypto/core_crypto';
import type {Algorithm, SymmetricKey} from 'metaserver/static/js/encrypted_folder/crypto/types';

export const decryptPerRevisionKey = async (
  perRevisionKeyInfo: PerRevisionKeyInfo,
  algorithm: Algorithm,
  fileKey: SymmetricKey
) => {
  const symmetricCrypto = createSymmetricCoreCrypto(fileKey.algorithm);
  const extras = symmetricCrypto.deserializeCryptoExtras(perRevisionKeyInfo.encryptionExtras);
  const keyData = await symmetricCrypto.decrypt(
    perRevisionKeyInfo.encryptedKeyData,
    fileKey,
    extras
  );
  return {
    algorithm,
    keyData,
  };
};
